import {
  ApplicationFormsTab,
  initialApplicationFormState,

} from "domain/feature/hub/company/meeting-room/settings/ApplicationFormsTab"
import { MEETING_ROOM_SETTINGS_API } from "domain/feature/hub/company/meeting-room/settings/api/constants"
import {
  buildSettingsSavePayload as buildSettingsSavePayload,
  EMPTY_SETTINGS_ID,
  mapGetResponseToFormState,
  MeetingRoomSettingsGetResponse,
} from "domain/feature/hub/company/meeting-room/settings/api/mappers"
import { RulesOfUseTab, RulesOfUseTabData } from "domain/feature/hub/company/meeting-room/settings/RulesOfUseTab"
import { PageHeader } from "domain/feature/hub/company/scouting/FormWrapper/list/style"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Button, Tab, Tabs } from "react-bootstrap"
import { GetFormat, PostFormat, useGet, usePost } from "sharedKernel/api"
import { trans } from "sharedKernel/i18n"
import { PageTitle } from "../pageLayoutStyles"
import { SettingsTabsWrapper, HeaderButtons, TabContentWrapper } from "./styles"
import { RequestFormState } from "domain/feature/hub/company/meeting-room/settings/ApplicationFormsTab/types"
import { showToast } from "components/toast"

const DEFAULT_RULES_DATA: RulesOfUseTabData = {
  publicSlug: '',
  days: {
    saturday: false,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    sunday: false,
  },
  openTime: '08:00',
  closeTime: '18:00',
  meetingSpacesLimit: 1,
  meetingDaysLimit: 1,
  meetingMinLeadTime: 1,
  meetingMaxDuration: 60,
  meetingAutomaticApproval: false,
  eventSpacesLimit: 1,
  eventDaysLimit: 1,
  eventMinLeadTime: 1,
  eventInterestDemonstration: false,
}

const SAVE_REQUEST_KEY = 'meeting-room-settings-save'
const GET_REQUEST_KEY = 'meeting-room-settings-get'

export const HubCompanyMeetingRoomSettingsPage = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState('rules')
  const [rulesData, setRulesData] = useState<RulesOfUseTabData>(DEFAULT_RULES_DATA)
  const [formsData, setFormsData] = useState<RequestFormState>(initialApplicationFormState)
  const [settingsId, setSettingsId] = useState<string>(EMPTY_SETTINGS_ID)

  const getRequest: GetFormat = useMemo(() => ({
    url: MEETING_ROOM_SETTINGS_API.BASE,
  }), [])

  const { data: getData } = useGet<MeetingRoomSettingsGetResponse>(getRequest, GET_REQUEST_KEY)

  const hasLoadedRef = useRef(false)
  useEffect(() => {
    if (getData && !hasLoadedRef.current) {
      const mapped = mapGetResponseToFormState(getData)
      setRulesData(mapped.rulesData)
      setFormsData(mapped.formsData)
      setSettingsId(getData.data.id)
      hasLoadedRef.current = true
    }
  }, [getData])

  const saveRequest: PostFormat = useMemo(() => ({
    url: MEETING_ROOM_SETTINGS_API.BASE,
    data: buildSettingsSavePayload(rulesData, formsData, settingsId),
    httpConfig: { timeout: 120000 },
  }), [rulesData, formsData, settingsId])

  const { refetch } = usePost<unknown>(saveRequest, SAVE_REQUEST_KEY, { enabled: false })
  const [isSaving, setIsSaving] = useState(false)

  const handleSave = async () => {
    setIsSaving(true)
    try {
      const result = await refetch()
      if (result.isError) return
      showToast('success', 'Configurações salvas com sucesso!')
    } finally {
      setIsSaving(false)
    }
  }

  return <>
    <PageHeader>
      <PageTitle>Configurações reserva</PageTitle>
      <HeaderButtons>
        <Button variant="outline-primary">Cancelar</Button>
        <Button variant="primary" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Salvando...' : 'Salvar'}
        </Button>
      </HeaderButtons>
    </PageHeader>
    <SettingsTabsWrapper>
      <Tabs
        activeKey={activeTab}
        onSelect={k => k && setActiveTab(k)}
      >
        <Tab title='Regras de uso' eventKey={'rules'}>
          <TabContentWrapper>
            <RulesOfUseTab
              formId="rules"
              data={rulesData}
              onChange={setRulesData}
            />
          </TabContentWrapper>
        </Tab>
        <Tab title='Formulários de solicitação' eventKey={'forms'}>
          <TabContentWrapper>
            <ApplicationFormsTab
              data={formsData}
              onChange={setFormsData}
            />
          </TabContentWrapper>
        </Tab>
      </Tabs>
    </SettingsTabsWrapper>
  </>
}
